import { styled } from 'styled-system/jsx'

const PageStack = styled('div', {
  base: {
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
    width: '100%',
  },
})

const PageHeader = styled('div', {
  base: {},
})

const PageTitle = styled('h1', {
  base: {
    fontFamily: 'display',
    fontSize: '28px',
    fontWeight: '700',
    color: 'quickpass.ink',
  },
})

const PageSubtitle = styled('p', {
  base: {
    fontFamily: 'body',
    fontSize: '15px',
    color: 'quickpass.inkSoft',
    marginTop: '4px',
  },
})

const QuietText = styled('p', {
  base: {
    fontFamily: 'body',
    fontSize: '14px',
    color: 'quickpass.inkSoft',
  },
})

const StatusPill = styled('span', {
  base: {
    alignSelf: 'flex-start',
    paddingX: '10px',
    paddingY: '3px',
    borderRadius: 'pill',
    fontFamily: 'body',
    fontSize: '12px',
    fontWeight: '600',
    backgroundColor: '#EFE9FF',
    color: '#5B3FCC',
  },
})

const LedgerDescription = styled('span', {
  base: {
    fontFamily: 'body',
    fontSize: '14px',
    fontWeight: '600',
    color: 'quickpass.ink',
  },
})

const LedgerMeta = styled('span', {
  base: {
    fontFamily: 'body',
    fontSize: '12px',
    color: '#8A8398',
  },
})

const BalanceActions = styled('div', {
  base: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '10px',
    marginTop: '16px',
  },
})

const MaintenanceList = styled('div', {
  base: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: '4px',
  },
})

const MaintenanceRow = styled('div', {
  base: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '8px',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '12px 0',
    borderTop: '1px solid #EFEDF5',
  },
})

const MaintenanceRowMain = styled('div', {
  base: {
    display: 'flex',
    flexDirection: 'column',
    gap: '2px',
  },
})

const MaintenanceForm = styled('div', {
  base: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    marginTop: '12px',
  },
})

const FormField = styled('div', {
  base: {
    display: 'flex',
    flexDirection: 'column',
    gap: '6px',
  },
})

const FormLabel = styled('label', {
  base: {
    fontFamily: 'body',
    fontSize: '13px',
    fontWeight: '600',
    color: 'quickpass.ink',
  },
})

const FormInput = styled('input', {
  base: {
    fontFamily: 'inherit',
    fontSize: '14px',
    color: 'quickpass.ink',
    backgroundColor: '#FFFFFF',
    border: '1.5px solid #E5E0F5',
    borderRadius: '10px',
    padding: '10px 12px',
    _focus: {
      outline: 'none',
      borderColor: 'quickpass.primary',
    },
  },
})

const FormTextarea = styled('textarea', {
  base: {
    fontFamily: 'inherit',
    fontSize: '14px',
    color: 'quickpass.ink',
    backgroundColor: '#FFFFFF',
    border: '1.5px solid #E5E0F5',
    borderRadius: '10px',
    padding: '10px 12px',
    minHeight: '90px',
    resize: 'vertical',
    _focus: {
      outline: 'none',
      borderColor: 'quickpass.primary',
    },
  },
})

const FormSelect = styled('select', {
  base: {
    fontFamily: 'inherit',
    fontSize: '14px',
    color: 'quickpass.ink',
    backgroundColor: '#FFFFFF',
    border: '1.5px solid #E5E0F5',
    borderRadius: '10px',
    padding: '10px 12px',
    cursor: 'pointer',
    _focus: {
      outline: 'none',
      borderColor: 'quickpass.primary',
    },
  },
})

const PhotoPicker = styled('div', {
  base: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },
})

const PhotoRow = styled('div', {
  base: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '8px',
  },
})

const PhotoThumbWrapper = styled('div', {
  base: {
    position: 'relative',
    width: '72px',
    height: '72px',
    borderRadius: '10px',
    overflow: 'hidden',
    border: '1.5px solid #E5E0F5',
  },
})

const PhotoThumbImage = styled('img', {
  base: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    display: 'block',
  },
})

const RemovePhotoButton = styled('button', {
  base: {
    position: 'absolute',
    top: '2px',
    right: '2px',
    width: '20px',
    height: '20px',
    borderRadius: 'pill',
    border: 'none',
    backgroundColor: 'rgba(0, 0, 0, 0.55)',
    color: '#FFFFFF',
    fontSize: '14px',
    lineHeight: '1',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
})

const AddPhotoLabel = styled('label', {
  base: {
    alignSelf: 'flex-start',
    display: 'inline-flex',
    alignItems: 'center',
    gap: '6px',
    paddingX: '14px',
    paddingY: '8px',
    borderRadius: '10px',
    border: '1.5px solid #E5E0F5',
    backgroundColor: '#FFFFFF',
    fontFamily: 'body',
    fontSize: '13px',
    fontWeight: '600',
    color: 'quickpass.primary',
    cursor: 'pointer',
    _hover: {
      borderColor: 'quickpass.primary',
    },
  },
})

const HiddenFileInput = styled('input', {
  base: {
    display: 'none',
  },
})

const PhotoError = styled('p', {
  base: {
    fontFamily: 'body',
    fontSize: '13px',
    color: '#C0392B',
  },
})

export {
  PageStack,
  PageHeader,
  PageTitle,
  PageSubtitle,
  QuietText,
  StatusPill,
  LedgerDescription,
  LedgerMeta,
  BalanceActions,
  MaintenanceList,
  MaintenanceRow,
  MaintenanceRowMain,
  MaintenanceForm,
  FormField,
  FormLabel,
  FormInput,
  FormTextarea,
  FormSelect,
  PhotoPicker,
  PhotoRow,
  PhotoThumbWrapper,
  PhotoThumbImage,
  RemovePhotoButton,
  AddPhotoLabel,
  HiddenFileInput,
  PhotoError,
}
